module.exports = {"zh-CN":{"sysName":"DTC后台管理系统"},"en":{"sysName":"DTC System"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/common/footer/footer-component-lan.json
// module id = Oo+9
// module chunks = 1